import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import EstablishmentsList from './EstablishmentsList';

//redux
import { ToastContainer } from 'react-toastify';

const Establishments = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Establecimientos' links={breadcrumbLinks} icon={'icon-map-pin-house'}/>
					<EstablishmentsList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Establishments;
